// GENERATED by @platform/contracts from specs/audit/main.tsp. Do not edit; run `pnpm generate`.
/* eslint-disable */
import { z } from 'zod';
export const AuditActorKind = z.enum(['user', 'assistant', 'workflow', 'system']);
/** Tenant identifier. The control plane's own resources use the literal `platform`. */
export const TenantId = z.string().regex(/^[a-z0-9][a-z0-9-]{1,62}$/);
/** Who did it, as the producing context recorded it (the event envelope's actor). */
export const AuditActor = z.object({
    kind: AuditActorKind,
    id: z.string().optional(),
    tenantId: TenantId.optional(),
});
/** ULID-style opaque identifier for records. */
export const RecordId = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/);
export const AuditOutcome = z.enum(['success', 'denied', 'failure']);
/** One immutable entry. `auditId` is time-ordered (ULID), so paging by it is paging by time. */
export const AuditEntry = z.object({
    auditId: RecordId,
    tenantId: TenantId,
    occurredAt: z.iso.datetime({ offset: true }),
    actor: AuditActor,
    action: z.string(),
    resourceKind: z.string(),
    resourceId: z.string().optional(),
    outcome: AuditOutcome,
    summary: z.string().optional(),
    requestId: z.string().optional(),
    sourceEventId: z.string(),
    sourceEventType: z.string(),
    correlationId: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
});
/** Machine-readable error codes. Never say whether a resource exists to a caller outside its tenant. */
export const ErrorCode = z.enum([
    'validation',
    'unauthenticated',
    'forbidden',
    'notFound',
    'conflict',
    'rateLimited',
    'internal',
]);
export const ErrorDetail = z.object({ path: z.string().optional(), message: z.string() });
/** The one error shape. Sent with the matching HTTP status. */
export const ErrorResponse = z.object({
    code: ErrorCode,
    message: z.string(),
    requestId: z.string(),
    details: z.array(ErrorDetail).optional(),
});
/** One validator set per operation, keyed by operationId. Same order as the route manifest. */
export const operations = {
    Audit_list: {
        operationId: 'Audit_list',
        method: 'GET',
        path: '/audit',
        params: z.object({}),
        query: z.object({
            cursor: z.string().optional(),
            limit: z.int32().min(1).max(200).default(50),
            since: z.iso.datetime({ offset: true }).optional(),
            until: z.iso.datetime({ offset: true }).optional(),
            action: z.string().optional(),
            resourceKind: z.string().optional(),
        }),
        responses: {
            '200': z.object({
                tenantId: TenantId,
                requestId: z.string(),
                items: z.array(AuditEntry),
                nextCursor: z.string().optional(),
            }),
            '400': ErrorResponse,
            '401': ErrorResponse,
            '403': ErrorResponse,
            '404': ErrorResponse,
        },
    },
};
//# sourceMappingURL=schemas.js.map